// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"5455e362","445":"982e4e0e","598":"8131e3d7"}[chunkId] + ".chunk.css";
};